import { getGroupID, getGroupName, getSelectedPeriod } from "./GroupContext";
import { postCharge } from "./sqldatabase/sqldatabase.service";

export async function addCharge(
  tenantId,
  chargeType,
  accountingPeriods,
  wbsCode,
  { id, period_start, period_end },
  isClientFacing,
  selectedReturnType = undefined,
) {
  chargeType = String(chargeType ?? "").toLowerCase();
  if (
    !chargeType.length ||
    !["fixed", "variable", "modelling"].includes(chargeType)
  ) {
    throw new Error("Error: Missing valid charge type");
  }

  if (!accountingPeriods && chargeType === "variable") {
    throw new Error("Error: Missing accounting periods");
  }

  if (!wbsCode?.length && !isClientFacing) {
    throw new Error("Error: Missing wbs code");
  }

  // [TODO] uncomment after wbs log migration
  // if (!id) {
  //   throw new Error("Error: Missing PoA ID");
  // }

  const selectedPeriod = getSelectedPeriod();
  if (!selectedPeriod) {
    throw new Error(
      `Error: Selected period not in group data ${period_start},${period_end}`,
    );
  }
  const returnStatus = selectedPeriod.return_status;

  const number_of_onesource_companies = accountingPeriods
    ?.filter((cap) => cap.onesource_sync)
    ?.filter((v, i, arr) => arr.indexOf(v) === i).length;

  const number_of_uk_companies = getSelectedPeriod()?.ukCompanyIDs?.length ?? 0;

  try {
    return postCharge(tenantId, {
      groupID: getGroupID(),
      group_name: getGroupName(),
      charge_type: chargeType,
      number_of_onesource_companies,
      number_of_uk_companies,
      poa_id: id,
      poa_start: period_start,
      poa_end: period_end,
      wbs_code: wbsCode,
      selectedReturnType,
      returnStatus,
      isClientFacing,
    });
  } catch (e) {
    console.log(e);
    return Promise.reject(e);
  }
}
